import { createContext, useContext } from 'react';
import type { Location, Membership, MembershipSummary, Restaurant, Role } from '@adop/shared';

export interface WorkspaceContextValue {
  /** All restaurants the signed-in user belongs to. */
  restaurants: MembershipSummary[];
  restaurant: Restaurant | null;
  location: Location | null;
  membership: Membership | null;
  role: Role | null;
  /** Locations the user can see, restricted by their membership. */
  visibleLocations: Location[];
  canManage: boolean;
  canOwn: boolean;
  setRestaurantId: (restaurantId: string) => void;
  setLocationId: (locationId: string) => void;
}

export const WorkspaceContext = createContext<WorkspaceContextValue | null>(null);

export function useWorkspace(): WorkspaceContextValue {
  const context = useContext(WorkspaceContext);
  if (!context) throw new Error('useWorkspace must be used within a WorkspaceProvider');
  return context;
}
